module.exports = __webpack_public_path__ + "static/fp3-experiencia-a79a149061ee484531523d2be7b7e3d2.webp";